mutation RestorePlatforms($ids: [ID!]!) {
  restorePlatforms(ids: $ids) {
    id
  }
}

